import find from 'lodash/find';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import reduce from 'lodash/reduce';
import React, { useEffect } from 'react';
import {
  TransformParameterTypes,
  TransformTypes,
  TRANSFORM_RULES_PROTO_ATTR,
  TRANSFORM_RULES_PROTO_FUNC,
  TRANSFORM_RULES_PROTO_NUM,
  TRANSFORM_RULES_PROTO_STR,
  TRANSFORM_RULES_PROTO_SYS_ATTR,
} from 'js/constants/schemaEditor';
import TransformsUtils from '../../../../../lib/TransformsUtils';
import TransformParameters from './TransformParameters';
import TransformRulesView from './TransformRulesView';
import useELT from 'new/components/flows/types/elt/CreateELTFlow/ELTFlow/useELT';

const containerStyle = {
  marginTop: 0,
  display: 'flex',
  flexDirection: 'column',
};

function TransformView(props) {
  const {
    level: currentLevel = 0,
    selectedBrowserType,
    transformData,
    allTransforms,
    allowedTransforms,
    groupedTransformRules,
    allAttributes,
    metaDataSpec,
    dataMaps,
    attrTransforms,
    viewClassName = 'transform-rule-view',
    isRoot = false,
    isLoadingDataMaps,
    colors,
  } = props;

  const _onSrcAttributeChanged = ({ type, name, parameters }) => {
    const { transformData } = props;

    let newSrcAttr =
      type === TransformParameterTypes.FUNCTION ? { type, name, parameters } : { type, name };

    let __newParams = {
      ...transformData.parameters,
      __srcAttr: newSrcAttr,
    };

    let transformObject = {
      ...transformData,
      parameters: __newParams,
    };
    props.onTransformChanged(transformObject);
  };

  const _onTransformRuleChange = (newRule) => {
    const { transformData } = props;
    let srcAttr = transformData?.parameters?.__srcAttr || {
      ...TRANSFORM_RULES_PROTO_ATTR,
      name: null,
    };
    let transformObject;
    //iterate over all params for this
    if (newRule === null) {
      return;
    }

    let transformRule = has(newRule, 'value') ? newRule.value : TransformTypes.TRANSFORM_NOOP;

    let parameters =
      newRule && has(newRule, 'params')
        ? reduce(
            newRule.params,
            (acc, currParam) => {
              let { typesAllowed, name } = currParam;
              let typeToUse =
                typesAllowed && !isEmpty(typesAllowed)
                  ? find(typesAllowed, (t) => t !== TransformParameterTypes.FUNCTION)
                  : null;

              let value =
                typeToUse && has(currParam, `default[${typeToUse}]`)
                  ? currParam.default[typeToUse]
                  : null;

              let paramData = null;
              switch (typeToUse) {
                case TransformParameterTypes.FUNCTION:
                  paramData = TRANSFORM_RULES_PROTO_FUNC;
                  break;
                case TransformParameterTypes.SYS_ATTR_REF:
                  paramData = TRANSFORM_RULES_PROTO_SYS_ATTR;
                  break;
                case TransformParameterTypes.ATTR_REF:
                  paramData = {
                    ...TRANSFORM_RULES_PROTO_ATTR,
                    name: srcAttr.type === TransformParameterTypes.ATTR_REF ? srcAttr.name : null,
                  };
                  break;
                case TransformParameterTypes.STRING_INP:
                  paramData = {
                    ...TRANSFORM_RULES_PROTO_STR,
                    value,
                  };
                  break;

                case TransformParameterTypes.NUMBER_INP:
                  paramData = {
                    ...TRANSFORM_RULES_PROTO_NUM,
                    value,
                  };
                  break;
                default:
                  paramData = null;
              }

              if (value !== null && paramData !== null) {
                acc[name] = paramData;
              }
              return acc;
            },
            { __srcAttr: srcAttr },
          )
        : { __srcAttr: srcAttr };
    transformObject = {
      type: TransformParameterTypes.FUNCTION,
      name: transformRule,
      parameters,
    };

    if (has(newRule, 'ignoreSrc') && newRule.ignoreSrc) {
      transformObject.parameters.__srcAttr.__ignoreSrc = true;
    }

    props.onTransformChanged(transformObject);
  };

  const _onTransformParamChanged = (newParamsMap) => {
    const { transformData } = props;

    var __newParams = { ...transformData.parameters, ...newParamsMap };

    var transformObject = {
      ...transformData,
      parameters: __newParams,
    };
    props.onTransformChanged(transformObject);
  };

  let selectedTransform = null;
  let transformParamsView = null;

  if (
    transformData &&
    TransformParameterTypes.FUNCTION === transformData.type &&
    TransformTypes.TRANSFORM_NONE !== transformData.name
  ) {
    selectedTransform = TransformsUtils.getTransformForRule(
      transformData.name,
      groupedTransformRules,
    );

    transformParamsView = (
      <TransformParameters
        level={currentLevel + 1}
        selectedBrowserType={selectedBrowserType}
        transformData={transformData}
        selectedTransform={selectedTransform}
        allAttributes={allAttributes}
        metaDataSpec={metaDataSpec}
        dataMaps={dataMaps}
        attrTransforms={attrTransforms}
        allTransforms={allTransforms}
        groupedTransformRules={groupedTransformRules}
        allowedTransforms={allowedTransforms}
        isLoadingDataMaps={isLoadingDataMaps}
        onSrcAttributeChanged={_onSrcAttributeChanged}
        onTransformParamChanged={_onTransformParamChanged}
        onTransformChanged={props.onTransformChanged}
        loadDataMaps={props.loadDataMaps}
        viewClassName={viewClassName}
        colors={colors}
      />
    );
  }

  return (
    <div style={containerStyle}>
      <div aria-label="transform rules view container">
        <TransformRulesView
          onTransformSelected={_onTransformRuleChange}
          selectedTransform={selectedTransform}
          allTransforms={allTransforms}
          allowedTransforms={allowedTransforms}
          groupedTransformRules={groupedTransformRules}
          isRoot={isRoot}
          onLoadReusableTransforms={props.onLoadReusableTransforms}
        />
      </div>
      {transformParamsView}
    </div>
  );
}

export default TransformView;
